import { render, staticRenderFns } from "./SkeletonTextCards.vue?vue&type=template&id=dada55f8"
import script from "./SkeletonTextCards.vue?vue&type=script&lang=js"
export * from "./SkeletonTextCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports